import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { environment } from '../../../../../environments/environment';
import { Config } from './nav.config';
import { Observable, Subscription, interval } from 'rxjs';
import { AppStateService } from '../../../../services/appState/app-state.service';

@Component({
  selector: 'glm-nav-list',
  templateUrl: './nav-list.component.html',
  styleUrls: ['./nav-list.component.css'],
})
export class NavListComponent implements OnInit {
  private updateSubscription: Subscription;
  subscription: Subscription;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private serviceAppState: AppStateService,
  ) {
    this.router.events.subscribe((param) => {
      if (param instanceof NavigationEnd) {
        this.currentRoute = param.url.split('/')[1]
          ? param.url.split('/')[1]
          : '';
      }
    });
  }

  currentRoute = '';
  config: Config = new Config();
  config_menu = environment.client_env;
  navItems;

  ngOnInit(): void {
    // this.activatedRoute.pathFromRoot[0].url.subscribe(u=>{
    //
    // })
    // this.config_menu = 'all'
    this.subscription = this.serviceAppState.currentMessage.subscribe(
      (message) => {
        if (message !== 'default') {
          this.navItems = this.config.getDynamicNavConfiguration();
        }
      },
    );

    this.navItems = this.config.getDynamicNavConfiguration();
    this.updateSubscription = interval(200000).subscribe((val) => {
      this.navItems = this.config.getDynamicNavConfiguration();
    });
  }

  newRoute(route) {
    this.currentRoute = route;
  }
}
